import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { getOntotisSingle, donwloadsStaffDetails } from "../../../utils/apicall/ontotisApi";
import { CONFIG } from "../../../utils/config";
import { handleError } from "../../../utils/error/error";
import { Ontotis, Person } from "../../../utils/types";
import SectionPersonOntotitaList from "./SectionPersonOntotitalist";
import SectionSubOntotitaList from "./SectionSubOntotitaList";
import { authService } from "../../../utils/authServices";
import DOMPurify from 'dompurify';


const OntotitaView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<Ontotis | null>(null);
  const [subOntotisName, setSubOntotisName] = useState<string>('');
  const [subOntotis, setSubOntotis] = useState<Ontotis[]>([]);
  const [persons, setPersons] = useState<Person[]>([]);
  const [isValidId, setIsValidId] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const filteredSegments = pathSegments.filter(segment => segment !== 'view');
  const dynamicId = id || filteredSegments[filteredSegments.length - 1];

  const loadData = useCallback(async () => {
   // console.log('dynamicId', dynamicId);
  if (dynamicId && !isNaN(Number(dynamicId))) {
      try {
        const response = await getOntotisSingle(parseInt(dynamicId, 10));
        if (response) {
          setData(response);
          setSubOntotis(response.children || []);
          setSubOntotisName(response.subontotisname);
          setPersons(response.persons || []);
          //console.log(response);
        }
      } catch (error) {
       handleError(error);
      }
    }
  }, [dynamicId]);

  useEffect(() => {
  //  console.log('dynamicId', dynamicId);
    if (!dynamicId || isNaN(Number(dynamicId))) {
     // setIsValidId(false);
     // navigate('/404');
    } else {
       setIsValidId(true);
      loadData();
    }
  }, [dynamicId, loadData, navigate]);


  useEffect(() => {
    //console.log("before");
    //console.log("location.state?.refresh", location.state?.refresh);
    if (location.state?.refresh) {
   //   console.log("Refresh triggered");
      // Call your refresh logic here (e.g., reload data or update UI)
      if (!dynamicId || isNaN(Number(dynamicId))) {
        // setIsValidId(false);
        // navigate('/404');
       } else {
          setIsValidId(true);
         loadData();
         authService.refreshAuthToken();
       }

      // Optional: Reset the state to prevent repeated refresh
      location.state.refresh = false; // This won't persist, as `location.state` is ephemeral.
    }
  }, [location.state]); 

  const handleBackClick = () => {
    navigate(-1);
  };


  const handleEditClick = (id: any)  => {
    navigate(CONFIG.urls.getOntotitaEditUrl_Admin(id!), {
      state: { returnTo: CONFIG.urls.getOntotitaViewUrl_Admin(id!) },
    });
  };

  const handleDownloadClick = async (id: number, title: string) => {
    try {
      const response = await donwloadsStaffDetails(id);
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${title}_${id}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        console.warn('Failed to download file:', response);
      }
    } catch (error) {
      console.error('An error occurred while downloading the file.', error);
    }
  };

  return (
    <div className="content">
    {/* <Breadcrumbs pathSegments={pathSegments} />*/} 
      <section className="ontotita py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h2 className="h4 text-primary fw-light py-3">{data?.title || ''}</h2>
            </div>
            <div className="col-md-5 text-end">
            
            {data?.can_edit && (
                      <button className="btn btn-warning btn-sm"  onClick={() => handleEditClick(data?.id?.toString() || '')}>
                      <i className="bi bi-pencil me-1"></i> Επεξεργασία
                      </button>
                    )}
            
             {/* <a
                href={CONFIG.urls.getOntotitaEditUrl_Admin(data?.id?.toString() || '')}
                className="btn btn btn-warning btn-sm"
              >
                <i className="bi bi-pencil me-1"></i> Επεξεργασία
             </a> */}
              <span onClick={handleBackClick}>
                <a className="btn btn-primary btn-sm ms-2">
                  <i className="bi bi-arrow-return-left me-1"></i> Επιστροφή
                </a>
              </span>
            </div>
          </div>
          <div className="row mt-3">
            {data?.description && (
              <div className="col-md-6 p-4 bg-white rounded-4">
                <div className="ontotisdescription py-2">
                <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(data.description || ''),
                }}
                 />
               
                </div>
              </div>
            )}
            <div className="col-md-6">
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex align-items-center rounded-top-3 bg-primary">
                  <span className="text-white" style={{ fontSize: '17px' }}>
                    Στοιχεία επικοινωνίας
                  </span>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                  <span className="ms-3">{data?.address}</span>
                </li>
                {data?.manager?.position && (
                  <li className="list-group-item d-flex align-items-center">
                    <i className="bi bi-person-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                    <span className="ms-3">
                      <b>{data.manager.position}</b> : {data.manager.name}
                    </span>
                  </li>
                )}
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-phone-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                  <span className="ms-3">
                    {data?.phone1}
                    {data?.phone2 ? `, ${data.phone2}` : ''}
                  </span>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-envelope-check-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                  <span className="ms-3">{data?.email}</span>
                </li>
                <li className="list-group-item d-flex align-items-center rounded-bottom-3">
                  <i className="bi bi-map-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                  <span className="ms-3">
                    <a href="#" className="btn btn-primary btn-sm">
                      Οδηγίες <i className="bi bi-arrow-right-circle"></i>
                    </a>
                  </span>
                </li>
              </ul>
             {/* <div onClick={() => handleDownloadClick(data?.id!, data?.title!)}>*/}
             <div>
              <a className="btn btn-warning mt-3">
                <i className="bi bi-file-earmark-spreadsheet me-2"></i>Εξαγωγή στοιχείων σε .xls
              </a>
            </div>
             {/* <a className="btn btn-warning mt-3" href="#">
                <i className="bi bi-file-earmark-spreadsheet me-2"></i> Εξαγωγή στοιχείων σε .xls
                </a>*/}
            </div>
          </div>
        </div>
      </section>
      {subOntotisName !== "-" && (
        <SectionSubOntotitaList 
            Ontotis={subOntotis} 
            parentid={dynamicId} 
            address={data?.address?.toString()}
            tk={data?.postalCode?.toString()}
            city={data?.city?.toString()}
            subontotisname={subOntotisName} 
            canedit={Boolean(data?.can_edit)} 
            
        />
    )}
     
      <SectionPersonOntotitaList data={persons} fromid={dynamicId}  canedit={Boolean(data?.can_edit)} />
    </div>
  );
};

export default OntotitaView;
